import { useLocation } from 'react-router';
import { getAudiogramWizardQueryParams } from 'utils/routes';

export default function useAudiogramQueryParams() {
  const { search } = useLocation();
  return getAudiogramWizardQueryParams(search);
}
